module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.fwqdizhi'),
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "exp: www.domain.com"
    },
    model: {
      value: (_vm.form.addr),
      callback: function($$v) {
        _vm.$set(_vm.form, "addr", $$v)
      },
      expression: "form.addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.fwqduankou'),
      "prop": "port"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "exp: 0000"
    },
    model: {
      value: (_vm.form.port),
      callback: function($$v) {
        _vm.$set(_vm.form, "port", $$v)
      },
      expression: "form.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60baa7a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/config/setting/edit.vue
// module id = 1058
// module chunks = 0